<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          em Hola 
            span.text-capitalize {{user.name}}
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
            small {{moment().locale('es').format('MMMM')}} 
            | {{ Math.ceil(moment().date() / 7) }}
            small a 
            | Semana
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .h2.mb-3.ad_text-primary
                | Esta Semana
              .col.ad_bg-gray.rounded-lg.py-4
                table.w-100.text-left.table-rounded-body
                  thead
                    tr
                      th.font-weight-bold
                        | Nombre usuario
                      th.text-center.font-weight-bold(width="10%")
                        | KPI Líder
                      th.text-center.font-weight-bold(width="10%")
                        | ICA
                      th.text-center.font-weight-bold(width="30%")
                        | Desafío semanal
                      th.text-center.font-weight-bold(width="10%")
                        | Planificación <br> semanal
                      th.text-center.font-weight-bold(width="10%")
                        | Diálogos <br> de desempeño
                      th.text-center.font-weight-bold(width="10%")
                        | Confirmación <br> de procesos
                      th.text-center.font-weight-bold(width="10%")
                        | Seguimiento <br> diario
                  tbody(v-if="loaded")
                    tr(v-for="(collab,n) in weeklyEvaluations")
                      td
                        div
                          | {{ collab.name }}
                      td
                        div.justify-content-center
                          | {{collab.kpi ? collab.kpi.toFixed(2): '--'}}%
                      td
                        div.justify-content-center
                          | {{ collab.ica ? collab.ica : 0}}%
                      td
                        div.justify-content-center
                          ul
                            li(v-for="wc in collab.weekly_challenge")
                              | {{wc.description}}
                      td
                        div.justify-content-center                          
                          div(v-if="collab.PS == 'Todo'")
                            i.icon-question.ad_text-warning.icon--1-5x.align-middle
                          div(v-else-if="collab.PS == 'N/A'")
                            i.icon-blocked.icon--1-5x.align-middle
                          div(v-else)
                            i.icon-checkmark.ad_text-success.icon--1-5x.align-middle
                      td
                        div.justify-content-center
                          div(v-if="collab.DDD == 'Todo'")
                            i.icon-question.ad_text-warning.icon--1-5x.align-middle
                          div(v-else-if="collab.DDD == 'N/A'")
                            i.icon-blocked.icon--1-5x.align-middle
                          div(v-else)
                            i.icon-checkmark.ad_text-success.icon--1-5x.align-middle
                      td
                        div.justify-content-center
                          div(v-if="collab.CP == 'Todo'")
                            i.icon-question.ad_text-warning.icon--1-5x.align-middle
                          div(v-else-if="collab.CP == 'N/A'")
                            i.icon-blocked.icon--1-5x.align-middle
                          div(v-else)
                            i.icon-checkmark.ad_text-success.icon--1-5x.align-middle
                      td
                        div.justify-content-center                          
                          div(v-if="collab.SD == 0")
                            i.icon-question.ad_text-warning.icon--1-5x.align-middle
                          div(v-else-if="collab.SD == 1")
                            i.icon-flickr2.ad_text-success.icon--1-5x.align-middle
                          div(v-else-if="collab.SD == 2")
                            i.icon-flickr.ad_text-success.icon--1-5x.align-middle
                          div(v-else-if="collab.SD == undefined")
                            i.icon-blocked.icon--1-5x.align-middle                                                    
                      
        .col-12.col-lg-6
          .card.ad_border1-secondary.rounded-xxl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-center
              .col
                h4.text-primary.text-regular.mb-0.ml-2
                  | Mis lideres
              .col-auto
                .h2.ad_text-secondary.mb-0.mr-2 {{`${totalPlans}/${collabsInformation.length}`}}
          
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.table-bg-white.w-100
                    thead
                      tr
                        td.px-3 Nombre
                        td.px-3.text-right  P.S
                        td.px-3.text-center DDD
                        td.px-3.text-center CP/SD
                    tbody.bg-white
                      tr.border-bottom(v-for="(collab, index) in collabsInformation")
                        td.px-3.py-2
                          | {{ collab.name }}
                        td.px-3.py-2.text-right
                          div(:class="classPlDone(index)")
                            | {{collab.plans.done}}/{{collab.plans.total}}
                            //- i.icono.icono-hecho.align-middle.ml-2
                          //- div.ad_text-grayMedio(v-else)
                          //-   | {{collab.plans.done}}/{{collab.plans.total}}
                            //- i.icono.icono-pendiente.align-middle.ml-2                          
                        td.px-3.py-2.text-center
                          | {{`${collab.meetings.done}/${collab.meetings.total}`}}
                        td.px-3.py-2.text-center
                          | {{`${collab.tracings.done}/${collab.tracings.total}`}}
        .col-12.col-lg-6
          .card.ad_border1-secondary.rounded-xxl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-center
              .col
                h4.text-primary.text-regular.mb-0.ml-2
                  | Objetivos de Desarrollo Personal
              .col-auto
                .h2.ad_text-secondary.mb-0.mr-2 {{`${totalPD}/${personalDevelopments.length}`}}
          
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.table-bg-white.w-100
                    thead
                      tr
                        td.px-3 Categoría
                        td.px-3.text-center Objetivo 
                        td.px-3.text-center Antiguedad
                    tbody.bg-white
                      tr.border-bottom(v-for="pers in personalDevelopments")
                        td.px-3.py-2
                          | {{pers.category.name}}
                        td.px-3.py-2.text-center
                          div
                            | {{pers.subcategory.name}}
                        td.px-3.py-2.text-center
                          | {{pers.date | WeekDuratByWeek}}
                        
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'ConsultorHome',

  data () {
    return {
      user: {},
      weeklyEvaluations: [],
      collabsInformation: [],
      personalDevelopments: [],
      totalPlans: 0,
      totalPD: 0,
      plan_con: null,
      collabsPlans: [],
      loaded: false
    }
  },
  methods: {
    moment,
    ...mapActions('consultant', [
      'actualWeekEvaluations', 'persDeveByPlanConOpen'
    ]),
    ...mapActions('user', [
      'collabsWeekInformation',
    ]),
    ...mapActions('plan_con', [
      'planByWeekCon', 'createPlanCo'
    ]),
    ...mapActions('weeklychallenge', [
      'getWcByUser'
    ]),
    getCollabsWeeklyChalenges() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.getWcByUser({user: vm.user.id}).then((response) => {
          vm.collabsPlans = response
          for (let index in vm.weeklyEvaluations) {            
            for (let c of vm.collabsPlans) {
              if (c) {
                if (vm.weeklyEvaluations[index].name == c.lider.name) {
                  vm.weeklyEvaluations[index].weekly_challenge = c.weekly_challenge
                  vm.weeklyEvaluations[index].ica = c.lider.ica
                  vm.weeklyEvaluations[index].kpi = c.lider.kpi
                  if (typeof vm.weeklyEvaluations[index].SDA == 'number' && typeof vm.weeklyEvaluations[index].SDB == 'number') {
                    vm.weeklyEvaluations[index].SD = 2
                  } else if (vm.weeklyEvaluations[index].SDA == 'Todo' && vm.weeklyEvaluations[index].SDB == 'Todo') {
                    vm.weeklyEvaluations[index].SD = 0
                  } else if (vm.weeklyEvaluations[index].SDA == 'Todo' || vm.weeklyEvaluations[index].SDB == 'Todo') {
                    vm.weeklyEvaluations[index].SD = 1
                  } else {
                    vm.weeklyEvaluations[index].SD = undefined
                  }
                }
              } else {
                vm.weeklyEvaluations[index].weekly_challenge = c
                vm.weeklyEvaluations[index].ica = c
                vm.weeklyEvaluations[index].kpi = c
              }
            }
          }
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    getCollabsWeekInformation() {
      return new Promise((resolve, reject) => {
        const vm = this;        
        vm.collabsWeekInformation(vm.user.id).then(response => {
          vm.collabsInformation = vm.$store.getters['user/getMyCollabsInformation']
          vm.getCollabsWeeklyChalenges().then(() => {
            vm.checkTotalPlDone()
            resolve()
          }, (error) => {
            reject(error)
          })
        })
      })            
    },
    getPerDevelopments() {
      const vm = this;
      vm.persDeveByPlanConOpen({plan: vm.plan_con._id}).then(response => {
        vm.personalDevelopments = vm.$store.getters['consultant/getPersonalDevelopments']
        vm.checkTotalPdDone()
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    checkTotalPdDone() {
      const vm = this
      for (let p of vm.personalDevelopments) {
        if (p.state.order == 2) {
          vm.totalPD++
        }
      }
    },
    checkTotalPlDone() {
      const vm = this
      for (let p of vm.collabsInformation) {
        if (p.plan) {
          if (p.plan.state.order == 2) {
            vm.totalPlans++
          }
        }
      }
    },
    createPlan() {
      return new Promise((resolve, reject) => {
        const vm = this
        let currentWeek = moment().isoWeek()
        vm.createPlanCo({
          name: `Plan semana ${currentWeek}`,
          week: currentWeek,
          consultant: vm.user.id
        }).then(() => {         
          vm.plan_con = vm.$store.getters['plan/getPlan']
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    classPlDone(index) {
      const vm = this
      return {
        'ad_text-success': vm.collabsInformation[index].plans.done == vm.collabsInformation[index].plans.total, 
        'ad_text-grayMedio': vm.collabsInformation[index].plans.done != vm.collabsInformation[index].plans.total
      }          
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    if (vm.user.profile.name == 'Consultor') {
      vm.planByWeekCon({date: Date.now(), id}).then(() => {
        vm.plan_con = vm.$store.getters['plan_con/getPlan']
        if (vm.plan_con) {
          vm.actualWeekEvaluations(id).then(() => {
            vm.weeklyEvaluations = vm.$store.getters['consultant/getWeeklyEvaluations']
            vm.getCollabsWeekInformation().then(() => {
              vm.loaded = true
              loading.hide()
            }, (error) => {
              loading.hide()
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: error,
                closeable: true,
                duration: 5000
              })  
            })            
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })                                       
        } else {
          vm.createPlan().then(() => {
            loading.hide()
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })
        }         
        vm.getPerDevelopments()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    } else {
      loading.hide()      
      vm.$router.replace({ path: '/permission' })
    }
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/consultor-home.vue